export default {
    init() {
      console.log('ACADEMY');
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  